var _path, _path2, _line;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcScrollRight(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0993 7.61043C13.4994 7.21834 13.4994 6.5741 13.0993 6.18201L8.36604 1.54338C8.14261 1.32441 7.78506 1.32441 7.56163 1.54338C7.33171 1.76869 7.33171 2.1389 7.56163 2.36421L11.4573 6.18201C11.8574 6.5741 11.8574 7.21834 11.4573 7.61043L7.56163 11.4282C7.33171 11.6535 7.33171 12.0237 7.56162 12.2491C7.78506 12.468 8.14261 12.468 8.36604 12.2491L13.0993 7.61043Z",
    fill: "#0859A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7607 -2.40956e-08C17.0846 -1.0788e-08 17.3472 0.262553 17.3472 0.586429L17.3472 13.2064C17.3472 13.5303 17.0846 13.7928 16.7607 13.7928C16.4369 13.7928 16.1743 13.5303 16.1743 13.2064L16.1743 0.586429C16.1743 0.262553 16.4369 -3.74032e-08 16.7607 -2.40956e-08Z",
    fill: "#0859A4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.7451,
    y1: 6.89282,
    x2: 0.500218,
    y2: 6.89282,
    stroke: "#0859A4",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScrollRight);
export default __webpack_public_path__ + "static/media/ic_scroll_right.af0dad58.svg";
export { ForwardRef as ReactComponent };